import { ReactFlowProvider } from 'reactflow';
import { AnalysisFlow } from 'modules';

export const AnalysisFlowPage = () => (
  <ReactFlowProvider>
    <AnalysisFlow />
  </ReactFlowProvider>
);
